import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Lock } from "lucide-react";
import { Badge } from "@/components/ui/badge";

type Props = {
  requiredTier: string | null | undefined;
  upgradeUrl?: string | null;
};

export function ModelLockBadge({ requiredTier, upgradeUrl }: Props) {
  const { t } = useTranslation();
  const tier = requiredTier ?? t("featureGate.alreadyOnHighest");
  const href = upgradeUrl ?? `/pricing${requiredTier ? `#${requiredTier.toLowerCase()}` : ""}`;
  return (
    <Badge variant="outline" className="text-xs flex items-center gap-1">
      <Lock className="h-3 w-3" />
      <Link to={href} className="hover:underline">
        {t("featureGate.lockedTitle", { tier })}
      </Link>
    </Badge>
  );
}

export default ModelLockBadge;
